$('.banner_slider').slick({
  dots: true,
  arrows:false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [{
    breakpoint: 1368,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  },{
    breakpoint: 1200,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
    }
  },{
    breakpoint: 991,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  },{
    breakpoint: 758,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  },{
    breakpoint: 720,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  },{
    breakpoint: 600,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }, {
    breakpoint: 500,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      dots: true
    }
  }]
});
$('.Releases_slider').slick({
  dots: false,
  arrows:true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [{
    breakpoint: 1368,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1
    }
  },{
    breakpoint: 1200,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1,
    }
  },{
    breakpoint: 991,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1
    }
  },{
    breakpoint: 758,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1
    }
  },{
    breakpoint: 720,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  },{
    breakpoint: 600,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }, {
    breakpoint: 500,
    settings: {
      autoplay:true,
      slidesToShow: 1,
      infinite: true,
      dots: false,
      arrows:false
    }
  }]
});
